var map = {
	"./de.json": [
		1182,
		1
	],
	"./de_CH.json": [
		1227,
		55
	],
	"./en.json": [
		625
	],
	"./en_CA.json": [
		1228,
		0
	],
	"./en_CH.json": [
		1183,
		1
	],
	"./en_GB.json": [
		1229,
		0
	],
	"./fr.json": [
		1230,
		56
	],
	"./fr_CA.json": [
		1231,
		0
	],
	"./fr_CH.json": [
		1184,
		1
	],
	"./it.json": [
		1232,
		57
	],
	"./it_CH.json": [
		1185,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 716;
module.exports = webpackAsyncContext;